export default {
  baseUrl: 'https://paygr.app',
  apiBaseUrl:
    'https://asia-southeast1-payment-link-ph.cloudfunctions.net/app/api/'
};
